import { render, staticRenderFns } from "./withhold.vue?vue&type=template&id=f905cecc&scoped=true&"
import script from "./withhold.vue?vue&type=script&lang=js&"
export * from "./withhold.vue?vue&type=script&lang=js&"
import style0 from "./withhold.vue?vue&type=style&index=0&id=f905cecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f905cecc",
  null
  
)

export default component.exports